import type { DataSetVersionsResponse, PaginatedTntData } from '../../timeInTransit/types';
import type { TimeInTransitService } from './';
import type {
  TntDataSetType,
  TntDataSet,
  TntSource,
  TntRecordsResponse,
  DownloadTntResponse,
  UploadProcessTntRecordsRequest,
  UploadTntResponse,
  TntJob,
  CreateDataSet,
  UpdateDataSetTypeFromUploadRequestV2,
  UploadProcessTntRecordsRequestV2,
  TntJobV2,
  DownloadTntRecordsRequestV2,
  DataSetResponseV2,
} from './types';

const mockTimeInTransitService: TimeInTransitService = {
  fetchTntJobsBulk: function (dataSetTypeIds: string[]): Promise<{ [key: string]: TntJob[] }> {
    throw new Error('Function not implemented.');
  },
  fetchTntDataSetsBulk: function (dataSetTypeIds: string[]): Promise<{ [key: string]: TntDataSet[] }> {
    throw new Error('Function not implemented.');
  },
  fetchDataSetVersionsBulk: function (tntDataSetIds: string[]): Promise<{ [key: string]: DataSetVersionsResponse[] }> {
    throw new Error('Function not implemented.');
  },
  fetchTntDataSetTypes: function (params: any): Promise<TntDataSetType[]> {
    throw new Error('Function not implemented.');
  },
  fetchTntDataSets: function (): Promise<{ dataSets: TntDataSet[] }> {
    throw new Error('Function not implemented.');
  },
  fetchTntSources: function (): Promise<TntSource[]> {
    throw new Error('Function not implemented.');
  },
  fetchDataSetsV2: function (): Promise<DataSetResponseV2[]> {
    throw new Error('Function not implemented.');
  },
  fetchTntRecords: function (params: any): Promise<TntRecordsResponse> {
    throw new Error('Function not implemented.');
  },
  fetchDataSetVersions: function (params: any): Promise<DataSetVersionsResponse> {
    throw new Error('Function not implemented.');
  },
  fetchTntRecordsByVersion: function (params: any): Promise<PaginatedTntData[]> {
    throw new Error('Function not implemented.');
  },
  downloadTntRecordsBySearch: function (body: DownloadTntRecordsRequestV2): Promise<DownloadTntResponse> {
    throw new Error('Function not implemented.');
  },
  downloadTntRecordsBySearchV2: function (body: DownloadTntRecordsRequestV2): Promise<DownloadTntResponse> {
    throw new Error('Function not implemented.');
  },
  updateDataSetTypeFromUpload: function (
    dataSetTypeId: string,
    body: UploadProcessTntRecordsRequest,
  ): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  fetchTntJobs: function (dataSetTypeId?: string | undefined): Promise<TntJob[]> {
    throw new Error('Function not implemented.');
  },
  fetchTntJobById: function (jobId: string, params: any): Promise<TntJob> {
    throw new Error('Function not implemented.');
  },
  fetchTntJobsV2: function (dataSetTypeId?: string | undefined): Promise<TntJobV2[]> {
    throw new Error('Function not implemented.');
  },
  fetchTntJobByIdV2: function (jobId: string): Promise<TntJobV2> {
    throw new Error('Function not implemented.');
  },
  createAsyncDataSetTypeFromUpload: function (body: UploadProcessTntRecordsRequest): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  createAsyncDataSetTypeFromUploadV2: function (body: UploadProcessTntRecordsRequestV2): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  updateDataSetType: function (body: TntDataSetType): Promise<TntRecordsResponse> {
    throw new Error('Function not implemented.');
  },
  updateDataSetTypeFromUploadV2: function (
    dataSetTypeId: string,
    body: UpdateDataSetTypeFromUploadRequestV2,
  ): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  deleteDataSetType: function (dataSetTypeId: string): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  createDataSet: function (body: CreateDataSet): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  uploadDataSet: function (body: string): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  deleteDataSet: function (body: string): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  writeDataSet: function (body: string): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  activateTnt: function (body: string): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  deactivateTnt: function (body: string): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  getTntStatus: function (body: string): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
  editDataSet: function (body: string): Promise<UploadTntResponse> {
    throw new Error('Function not implemented.');
  },
};

export default mockTimeInTransitService;
